import { useChangeSim } from '../../common/hooks/useChangeSim';
import { closeMsg, t, yourOldSIMCardWillNowStopWorkingMsg } from '../../common/i18n/index.js';
import { SimType, type Subscription } from '../../generated/api/models.js';
import { DialogWrapper, buttonsForSubmitAndBack } from '../DialogWrapper/index.js';
import type { CommonError } from '../../common/types/errors.js';
import type { CategoryKey } from '../../common/utils/categoryUtils.js';

export interface ChangeSimCardConfirmDialogProps {
  category: CategoryKey;
  errors?: CommonError[];
  isEoe: boolean;
  isLoading?: boolean;
  onCloseDialog: () => void;
  simCardNumber: string;
  sub: Subscription;
}

export const ChangeSimCardConfirmDialog = (props: ChangeSimCardConfirmDialogProps) => {
  const { category, errors, isEoe, isLoading, onCloseDialog, simCardNumber, sub } = props;
  const changeSim = useChangeSim(sub, isEoe);

  return (
    <DialogWrapper
      buttons={
        errors
          ? buttonsForSubmitAndBack(onCloseDialog, undefined, t.WOYD(closeMsg))
          : buttonsForSubmitAndBack(
              onCloseDialog,
              () => changeSim(SimType.PHYSICAL, category, simCardNumber), // We always use `PHYSICAL`, even for Laitenetti (M2M) which could be MINI_MICRO or NANO, since we have no way of knowing what the customer actually has. So here `PHYSICAL` doesn't mean it's the "classic" `PHYSICAL`, but just any kind of physical, as opposed to eSIM.
              undefined,
              undefined,
              'OK',
              undefined,
              isLoading
            )
      }
      header={errors ? t.WBQT('SIM card activation failed') : t.SJ3Y(yourOldSIMCardWillNowStopWorkingMsg)}
      onCloseDialog={onCloseDialog}
    >
      {errors ? (
        <p>
          {t.WD0I(
            'Please double check you used the correct SIM card number. If the problem persists, please contact Elisa customer service.'
          )}
        </p>
      ) : (
        <p>{t.WHE6('New SIM card gets activated immediately after change.')}</p>
      )}
    </DialogWrapper>
  );
};
